import {Currency} from '../api/types/carvagoApiTypes';
import {AppLanguage} from '../types/AppLanguage';

export const languageToCurrencyMap = {
  cs: 'CZK',
  pl: 'PLN',
  sk: 'EUR',
  de: 'EUR',
  en: 'EUR',
  es: 'EUR',
  it: 'EUR',
  fr: 'EUR',
  nl: 'EUR',
  sv: 'EUR',
  ro: 'EUR',
  hu: 'EUR',
  sl: 'EUR',
  hr: 'EUR',
  bg: 'EUR',
  lt: 'EUR',
  lv: 'EUR',
  et: 'EUR',
  da: 'EUR',
  pt: 'EUR',
  fi: 'EUR',
} as const satisfies Record<AppLanguage, Currency>;
